import { EventSource } from "../event-source";
import type { Message } from "../message";
import type { Thread, ThreadDriver } from "../thread";

/**
 * Abstract base class for model drivers.
 * Implements common functionality and defines the interface for model-specific implementations.
 */
export abstract class BaseModelDriver extends EventSource implements ThreadDriver {
  /**
   * Process and send a thread to the model and return the updated thread
   */
  abstract sendThread(thread: Thread): Promise<Thread>;

  /**
   * Stream a response from the model
   */
  abstract streamThread(
    thread: Thread,
  ): AsyncGenerator<{ stream: AsyncGenerator<string, void>; message: Message }, Thread>;
}
